import React from 'react'
import HelpPopup from '../helpPopup/HelpPopup'

import VideoIcon from '../../../assets/codicons/play.svg'
import ProfileIcon from '../../../assets/codicons/profile.svg'
import FlameIcon from '../../../assets/codicons/flame.svg'

import IntroductoryIcon from '../../../assets/codicons/introductory.svg'
import BeginnerIcon from '../../../assets/codicons/beginner.svg'
import ModerateIcon from '../../../assets/codicons/moderate.svg'
import IntermediateIcon from '../../../assets/codicons/intermediate.svg'
import AdvancedIcon from '../../../assets/codicons/advanced.svg'

import Measure from 'react-measure'
import numeral from 'numeral'
import PropTypes from 'prop-types'

class ProductInformation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      flameHovered: false
    }

    this.initialCheck = true
    this.renderBestSeller = this.renderBestSeller.bind(this)
    this.renderDifficultyIcon = this.renderDifficultyIcon.bind(this)
  }

  renderBestSeller() {
    if (this.props.memberCount || this.props.memberCount === 0) {
      let popupTrigger = (
        <a href='#'>
          <FlameIcon />
          <span className='compact'>
            {numeral(this.props.memberCount).format('0[.]0a')}
          </span>
          <span className='full'>{this.props.memberCount}</span>
        </a>
      )
      if (this.props.product['bestSeller?']) {
        return (
          <div className='product-members most-popular-container'>
            <div className='most-popular'>
              <HelpPopup
                trigger={popupTrigger}
                topOffset={-5}
                onHover={() => {
                  this.setState({ flameHovered: true })
                }}
                offHover={() => {
                  this.setState({ flameHovered: false })
                }}
              >
                <span className='glyphicon glyphicon-fire' />
                Most Popular Series
              </HelpPopup>
            </div>
          </div>
        )
      } else {
        return (
          <div className='product-members'>
            <ProfileIcon />
            <span className='compact'>
              {numeral(this.props.memberCount).format('0[.]0a')}
            </span>
            <span className='full'>{this.props.memberCount}</span>
          </div>
        )
      }
    }
  }

  renderDifficultyIcon() {
    if (this.props.difficultyLevel === 'introductory') {
      return <IntroductoryIcon />
    } else if (this.props.difficultyLevel === 'beginner') {
      return <BeginnerIcon />
    } else if (this.props.difficultyLevel === 'moderate') {
      return <ModerateIcon />
    } else if (this.props.difficultyLevel === 'intermediate') {
      return <IntermediateIcon />
    } else if (this.props.difficultyLevel === 'advanced') {
      return <AdvancedIcon />
    }
  }

  titleHeightChanged(contentDim) {
    if (this.oldHeight !== contentDim.client.height && !this.initialCheck) {
      this.props.onTitleHeightChange(contentDim.client.height)
    }
    this.oldHeight = contentDim.client.height
    this.initialCheck = false
  }

  renderDifficultyLabel() {
    if (this.props.difficultyLevel) {
      let mobileProductDifficulty = this.props.difficultyLevel
        ? this.props.difficultyLevel.substring(0, 3)
        : null
      return (
        <div className='product-difficulty plan-stats'>
          <div className='level-icon'>{this.renderDifficultyIcon()}</div>
          <div className='level level-lg'>{this.props.difficultyLevel}</div>
          <div className='level level-small'>{mobileProductDifficulty}</div>
        </div>
      )
    }
  }

  renderWorkoutCount() {
    if (this.props.workoutCount) {
      return (
        <div className='product-price-container'>
          <span>
            <div className='product-videos'>
              <VideoIcon />
              {this.props.workoutCount}
            </div>
          </span>
        </div>
      )
    }
  }

  render() {
    let productCoaches

    if (this.props.includeInstructorName) {
      productCoaches = this.props.product.coachLabel()
    }

    let favoriteButton
    if (this.props.renderItemFavoriteButton) {
      favoriteButton = this.props.renderItemFavoriteButton()
    }

    let zIdx = this.state.flameHovered ? 20000 : 10

    return (
      <div className='product-info-container' style={{ zIndex: zIdx }}>
        <div className='product-meta'>
          <Measure
            client
            onResize={(contentDim) => {
              if (this.props.onTitleHeightChange) {
                this.titleHeightChanged(contentDim)
              }
            }}
          >
            {({ measureRef }) => (
              <div className='varied-height'>
                <div className='product-title-container' ref={measureRef}>
                  <h4 className='product-title'>
                    <a href={this.props.itemUrl} data-refmarks-element='true'>
                      {this.props.title}
                    </a>
                  </h4>
                  <div className='favorite-button-inline hidden-xs'>
                    {favoriteButton}
                  </div>
                </div>
                {this.props.parentLabel}
                <div className='product-coach'>
                  {this.props.coaches?.map((coach, idx) => {
                    let coachName = `${coach.firstName} ${coach.lastName}`
                    if (
                      this.props.coaches.length > 1 &&
                      idx === this.props.coaches.length - 1
                    ) {
                      coachName = ' & '.concat(coachName)
                    }
                    if (
                      this.props.coaches.length > 0 &&
                      idx < this.props.coaches.length - 2
                    ) {
                      coachName += ', '
                    }
                    if (coach.coachInfo) {
                      return (
                        <a
                          key={coach.coachInfo.slug}
                          href={'/instructors/' + coach.coachInfo.slug}
                          data-refmarks-element='true'
                        >
                          {coachName}
                        </a>
                      )
                    } else {
                      return <span key={idx}>{coachName}</span>
                    }
                  })}
                </div>
              </div>
            )}
          </Measure>
          <div className='product-details-push' />
          <div className='product-details'>
            {this.renderWorkoutCount()}
            {this.renderDifficultyLabel()}
            {this.renderBestSeller()}
          </div>
        </div>
      </div>
    )
  }
}

ProductInformation.defaultProps = {
  includeInstructorName: true
}

ProductInformation.propTypes = {
  coaches: PropTypes.array,
  difficultyLevel: PropTypes.string,
  memberCount: PropTypes.number,
  workoutCount: PropTypes.number,
  onTitleHeightChange: PropTypes.func,
  renderItemFavoriteButton: PropTypes.func,
  includeInstructorName: PropTypes.bool,
  itemUrl: PropTypes.string,
  product: PropTypes.object,
  title: PropTypes.string,
  parentLabel: PropTypes.node
}

export default ProductInformation
